type TAjaxForm = ReturnType<typeof import('widgets/forms/AjaxForm').default>;
type TInputSelectInstance = InstanceType<ReturnType<typeof import('widgets/forms/InputSelect').default>>;
type TLanguageOption = {
    name: string,
    value: string,
};

/**
 * @description Country selector switcher
 * @param AjaxForm Base widget for extending
 * @returns Country Selector class
 */
export default function (AjaxForm: TAjaxForm) {
    /**
     * @class CountrySelectorForm
     * @augments AjaxForm
     * @classdesc Base `CountrySelectorForm` implementation
     */
    class CountrySelectorForm extends AjaxForm {
        /**
         * @description Returns Widget configuration object
         */
        prefs() {
            return {
                languages: <Record<string, TLanguageOption[]>>{},
                ...super.prefs()
            };
        }

        /**
         * @description Update languages on country change
         * @param el Country selector
         */
        onCountryChange(el: TInputSelectInstance) {
            const country = el.getValue();

            this.getById<TInputSelectInstance>('languageSelector', (languageSelector) => {
                languageSelector.updateOptions(this.prefs().languages[country]);
            });
        }

        /**
         * @description Widget initialization logic
         * @listens "countrySelector.show"
         */
        getFormFields() {
            const container = document.createElement('div');
            const fields = <Record<string, string|number|boolean>> super.getFormFields();

            container.innerHTML = String(this.ref('html').data('querystring'));
            fields.action = String(this.ref('html').data('action'));
            fields.queryString = container.innerText;

            return fields;
        }
    }

    return CountrySelectorForm;
}
